import styled from 'styled-components';

export default styled.header`
  width: 100%;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 1000;
  padding: 0.8rem 0;
  background: #fdfaf5;
  border-bottom: 1px solid #ece6dc;
  transition: background 0.3s ease-in-out;

  .header__container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1.5rem;
  }

  .logo {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }

  .nav__wrapper {
    flex: 1;
    display: flex;
    justify-content: center;
    nav {
      ul {
        display: flex;
        align-items: center;
        gap: 1.5rem;
        li {
          a {
            color: #6b5f56;
            font-size: 1.5rem;
            font-weight: 600;
            padding: 0.6rem 0.8rem;
            border-radius: 8px;
            text-decoration: none;
            white-space: nowrap;
          }
          &:hover a {
            color: #2b2420;
          }
        }
      }
    }
  }

  .header__actions {
    display: flex;
    align-items: center;
    gap: 0.8rem;
    flex-shrink: 0;
  }

  .header__cta {
    background: var(--secondary);
    color: #fff;
    padding: 0.8rem 1.6rem;
    border-radius: 12px;
    font-weight: 700;
    font-size: 1.4rem;
    text-decoration: none;
    white-space: nowrap;
    box-shadow: 0 10px 20px rgba(255, 163, 53, 0.25);
  }

  .searchIcon__wrapper {
    border-radius: 12px;
    padding: 0.7rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #1e5bbf;
    color: #fff;
    cursor: pointer;

    svg {
      width: 20px;
      height: 20px;
    }
  }

  .searchIcon {
    display: none;
  }

  .ctaMobile {
    display: none;
  }

  .mobileMenuCloseBtn,
  .mobileNavBg,
  .mobileIcon,
  .mobileMenuBtn {
    display: none;
  }

  @media only screen and (max-width: 900px) {
    .nav__wrapper nav ul {
      gap: 1rem;
      li a {
        font-size: 1.3rem;
        padding: 0.5rem 0.6rem;
      }
    }

    .header__cta {
      font-size: 1.3rem;
      padding: 0.7rem 1.2rem;
    }
  }

  @media only screen and (max-width: 768px) {
    .header__container {
      justify-content: space-between;
    }

    .header__actions {
      display: none;
    }

    .mobileMenuCloseBtn,
    .mobileNavBg,
    .mobileIcon,
    .mobileMenuBtn {
      display: initial;
    }

    .nav__wrapper {
      justify-content: flex-end;
      nav {
        z-index: 1002;
        position: fixed;
        top: 0;
        right: 0;
        width: min(86%, 360px);
        transform: translateX(100%);
        background-color: #1e5bbf;
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: 0.3s ease transform;
        ul {
          width: 90%;
          margin: 0 auto;
          flex-direction: column;
          gap: 1rem;
          li {
            display: block;
            margin: 0.6rem 0;
            a {
              width: 100%;
              padding: 0.7rem 1rem;
              border-radius: 8px;
              color: #fff;
              font-size: 1.5rem;
            }
            &.searchIcon {
              display: none;
            }
            &.ctaMobile {
              display: block;
            }
          }
        }
        .mobileMenuCloseBtn {
          color: #fff;
          position: absolute;
          top: 10px;
          right: 10px;
          border-color: #fff;
          &:hover {
            color: #fff;
          }
        }
      }
      &.open {
        nav {
          transform: translateX(0);
        }
      }
      .mobileNavBg {
        z-index: 1001;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transition: opacity 0.6s linear 0s;
        background: rgba(0, 0, 0, 0.5);
      }
    }

    .mobileIcon {
      display: flex;
      gap: 1rem;
    }

    .mobileMenuBtn {
      svg {
        width: 28px;
        height: 28px;
      }
    }
  }
`;
